import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const ShortUrlResolver: React.FC = () => {
  const { shortCode } = useParams<{ shortCode: string }>()
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!shortCode) {
      setError(true)
      return
    }

    fetch(`/api/agents/p/${shortCode}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.data?.subdomain && data.data?.seo_title) {
          const { subdomain, seo_title } = data.data
          // Preservar UTM params si vienen en la URL
          const params = window.location.search
          window.location.replace(
            `https://${subdomain}.innovagent.tech/property/${seo_title}${params}`
          )
        } else {
          setError(true)
        }
      })
      .catch(() => setError(true))
  }, [shortCode])

  if (error) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <p className="text-white text-xl font-semibold mb-2">Enlace no encontrado</p>
          <p className="text-white/60 text-sm">Este enlace no existe o ha expirado.</p>
          <a href="https://innovagent.tech" className="mt-6 inline-block text-blue-400 hover:text-blue-300 text-sm">
            Ir a InnovAgent
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white/60 text-sm">Redirigiendo...</p>
      </div>
    </div>
  )
}

export default ShortUrlResolver
